import React, { useRef, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

function buildGeometry(shape) {
  switch (shape) {
    case 'torusKnot':
      return new THREE.TorusKnotGeometry(1, 0.32, 128, 16, 2, 3);
    case 'octahedron':
      return new THREE.OctahedronGeometry(1.7, 0);
    default:
      return new THREE.IcosahedronGeometry(1.6, 0);
  }
}

function Shape({ color, shape, speed }) {
  const meshRef = useRef();
  const geometry = useMemo(() => buildGeometry(shape), [shape]);

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    if (!meshRef.current) return;
    meshRef.current.rotation.x = t * 0.1 * speed;
    meshRef.current.rotation.y = t * 0.16 * speed;
    meshRef.current.position.y = Math.sin(t * 0.5) * 0.1;
  });

  return (
    <mesh ref={meshRef} geometry={geometry}>
      <meshBasicMaterial color={color} wireframe />
    </mesh>
  );
}

export default function ThreeShape({ color = '#FF5A1F', shape = 'icosahedron', speed = 1, style }) {
  return (
    <div style={{ width: '100%', height: '100%', ...style }}>
      <Canvas
        camera={{ position: [0, 0, 4.5], fov: 45 }}
        gl={{ alpha: true, antialias: true }}
        style={{ background: 'transparent' }}
      >
        <Shape color={color} shape={shape} speed={speed} />
      </Canvas>
    </div>
  );
}
